export const Expiration = "/loan-calc/expiration";
export const Evenness = "/loan-calc/evenness";
export const CashFlow = "/cashflow";